import type {RequestTokenMap} from './token';

export function withToken(fetcher: typeof fetch, token: string): typeof fetch {
    return (
        requestInfo: RequestInfo | URL,
        requestInit: RequestInit | undefined,
    ) => {
        if (!token) {
            throw new Error('No token provided');
        }
        const headers = new Headers(requestInit?.headers);
        headers.set('token', `${token}`);
        return fetcher(requestInfo, {...requestInit, headers});
    };
}

export function withPin(fetcher: typeof fetch, pin: string): typeof fetch {
    return (
        requestInfo: RequestInfo | URL,
        requestInit: RequestInit | undefined,
    ) => {
        const headers = new Headers(requestInit?.headers);
        headers.set('pin', `${pin}`);
        return fetcher(requestInfo, {...requestInit, headers});
    };
}

export type InfinityErrorMessage = RequestTokenMap['403']['result'] & string;

export function getErrorCode(error: InfinityErrorMessage) {
    
}

export type InfinityErrorCode = ReturnType<typeof getErrorCode>;
